import type { AllRouteEndpoints } from "../routeTypes";

export const conversationalSettings = "/:app_group_id/conversational/settings";

export const conversationalSettingsCacheKeys: AllRouteEndpoints[] = ["/:app_group_id/conversational/settings"];
